angular.module('ikeweb.spike.capture').factory('captureFactory', ['SpikeUtil', '$translate', 'folderService',
    function(SpikeUtil, $translate, folderService) {
        var PARSE_CAPTURE_CLASS_NAME = 'SpikeCapture';
        var PARSE_SHAREDCAPTURE_CLASS_NAME = 'SharedCapture';

        function createPolygon(measurement) {
            return {
                type: measurement.type,
                shape: measurement.svg,
                dimensions: measurement.dimensions,
                area: measurement.area,
                totalDimension: measurement.circumference,
                id: measurement.id
            };
        }

        function filterBy(type) {
            return function(measurement) {
                return measurement.type === type;
            };
        }

        function createMeasurement(type) {
            return function(polygon) {
                return {
                    type: type,
                    svg: polygon.shape,
                    dimensions: polygon.dimensions,
                    area: polygon.area,
                    circumference: polygon.totalDimension,
                    id: polygon.id
                };
            };
        }

        function populateImageResolution(context) {
            var captureData = context.get('capture');
            context.resolution = captureData.steps[0].camera.resolution;
        }

        function findLocation(captureData, type) {
            var locations = captureData.steps[0].location;
            var location = locations.filter(function(location) {
                return location.type === type;
            });
            if (location.length > 0 && location[0].latitude !== 0 && location[0].longitude !== 0) {
                return location[0];
            }
            return null;
        }

        function populateMeasurements(context) {
            var captureData = context.get('capture');
            /* eslint-disable */
            context.measurements = {
                alignment_polygons: captureData.measurements.filter(filterBy('alignment')).map(createPolygon),
                cutout_polygons: captureData.measurements.filter(filterBy('cutout')).map(createPolygon),
                main_polygons: captureData.measurements.filter(filterBy('main')).map(createPolygon),
                polylines: captureData.measurements.filter(filterBy('line')).map(createPolygon)
            };
            /* eslint-enable */
        }

        function populateNote(context) {
            var note = context.get('note');
            context.note = note ? note : '';
        }

        function getAlignedImage() {
            var alignedImage = this.get('alignedImage');
            return alignedImage ? alignedImage.url() : '';
        }

        function getScaledImage() {
            var scaledImage = this.get('scaledImage');
            return scaledImage ? scaledImage.url() : '';
        }

        function getThumbnailImage() {
            var thumbnailImage = this.get('thumbnailImage');
            return thumbnailImage ? thumbnailImage.url() : '';
        }

        function getMeasurementsSVGString() {
            var measurements = this.get('capture').measurements;
            var resolution = this.resolution;
            var innerSVG = ['<svg xmlns=\'http://www.w3.org/2000/svg\' width="' + resolution.width + '" height="' + resolution.height + '">'];

            measurements.forEach(function(m) {
                innerSVG.push(m.svg);
            });

            innerSVG.push('</svg>');

            return innerSVG.join('');
        }

        function getMeasurementsSVG() {
            var resolution = this.resolution;
            var svg = SpikeUtil.SVG.tag('svg');
            svg.setAttribute('preserveAspectRatio', 'xMinYMin');
            svg.setAttribute('viewBox', '0 0 ' + resolution.width + ' ' + resolution.height);

            var parser = new DOMParser();

            var dom = parser.parseFromString(getMeasurementsSVGString.call(this), 'image/svg+xml');
            var el = svg.ownerDocument.importNode(dom.documentElement, true);
            svg.appendChild(el);
            return svg;
        }

        function getName() {
            return this.get('name');
        }

        var SharedCapture = Parse.Object.extend(PARSE_SHAREDCAPTURE_CLASS_NAME, {
            populate: function() {
                populateMeasurements(this);
                populateImageResolution(this);
                populateNote(this);
            },
            getAlignedImage: getAlignedImage,
            getScaledImage: getScaledImage,
            getThumbnailImage: getThumbnailImage,
            getMeasurementsSVG: getMeasurementsSVG,
            getUnits: function() {
                return this.get('units');
            },
            getZoomArea: function() {
                return this.get('zoomArea');
            },
            getName: getName,
            getMeasurementsSVGString: getMeasurementsSVGString
        });

        var Capture = Parse.Object.extend(PARSE_CAPTURE_CLASS_NAME, {

            populate: function() {
                var captureData = this.get('capture');
                this.hva = captureData.steps[0].camera.calibration.basic.horizontal;
                this.vva = captureData.steps[0].camera.calibration.basic.vertical;
                this.distance = captureData.steps[0].range.distance;
                populateMeasurements(this);
                populateImageResolution(this);
                populateNote(this);
            },

            serialize: function() {
                this.get('capture').measurements = [].concat(
                    this.measurements.alignment_polygons.map(createMeasurement('alignment')),
                    this.measurements.main_polygons.map(createMeasurement('main')),
                    this.measurements.cutout_polygons.map(createMeasurement('cutout')),
                    this.measurements.polylines.map(createMeasurement('line')));
            },

            isAlignmentDone: function() {
                if (!this.get('capture')) {
                    return false;
                }

                var measurements = this.get('capture').measurements;
                for (var i = 0; i < measurements.length; i++) {
                    if (measurements[i].type === 'alignment') {
                        return true;
                    }
                }

                return false;
            },

            getExportFilename: function() {
                var timestamp = this.get('timestamp');
                var folder = this.get('folder');
                var foldername = folder ? folder.get('name') || ' ' : '';
                var filename = foldername + ' ' + this.getName() + ' ' + moment(timestamp).format('YYYY-MM-DD_HH:mm:ssZ');
                return SpikeUtil.cleanFileName(filename, {
                    replacement: ' '
                });
            },

            isInFolder: function(folder) {
                return this.get('folder') && this.get('folder').id && this.get('folder').id === folder.getId();
            },

            getTargetLocation: function() {
                return findLocation(this.get('capture'), 'target');
            },
            hasPosition: function() {
                return !!findLocation(this.get('capture'), 'local');
            },
            getTimeStamp: function() {
                return this.get('timestamp');
            },
            getCaptureUuid: function() {
                return this.get('captureuuid');
            },
            setName: function(value) {
                this.set('name', value);
            },
            setNote: function(value) {
                this.set('note', value);
            },
            getId: function() {
                return this.id;
            },
            getNote: function() {
                return this.get('note');
            },
            getName: getName,
            getMeasurementsSVGString: getMeasurementsSVGString,
            getMeasurementsSVG: getMeasurementsSVG,
            getAlignedImage: getAlignedImage,
            getScaledImage: getScaledImage,
            getThumbnailImage: getThumbnailImage
        });

        function create() {
            return new Capture();
        }

        return {
            Capture: Capture,
            SharedCapture: SharedCapture,
            create: create
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/capture/capture.factory.js
// module id = 513
// module chunks = 0